import { render, staticRenderFns } from "./SeatsCounter.vue?vue&type=template&id=6bc0d714&scoped=true"
import script from "./SeatsCounter.vue?vue&type=script&lang=js"
export * from "./SeatsCounter.vue?vue&type=script&lang=js"
import style0 from "./SeatsCounter.vue?vue&type=style&index=0&id=6bc0d714&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc0d714",
  null
  
)

export default component.exports